import { useAuthStore } from '@store/authStore';
import { useChatSocketLifecycle } from '@hooks/useUnreadMessages';
import { GlobalChatNotifications } from './GlobalChatNotifications';

/** Keeps chat socket alive and shows global message alerts for wholesaler/restaurant users. */
export function ChatNotificationsProvider() {
  const role = useAuthStore((s) => s.user?.role);

  useChatSocketLifecycle();

  if (role === 'wholesaler') {
    return <GlobalChatNotifications messagesBasePath="/wholesaler/messages" />;
  }
  if (role === 'restaurant') {
    return <GlobalChatNotifications messagesBasePath="/restaurant/messages" />;
  }
  return null;
}
